import { useEffect, useState } from 'react';

const useShowFloatingButton = () => {
  const SHOW_BUTTON_BREAKPOINT = 450;
  const [showButton, setShowButton] = useState(false);

  const handleScroll = () => {
    const position = window.scrollY;
    setShowButton(position >= SHOW_BUTTON_BREAKPOINT);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return {
    showButton
  };
};

export default useShowFloatingButton;
